export default {
  name: "workkardDetail",
  api: {
    endpoints: {
      // Master data / carrier
      // Only master data is migrated onto the core gateway so far.
      masterData: { url: "/1.0/getwkinfoapi", method: "GET", gateway: true },
      workkardCarrier: { url: "1.0/wkcarrier", method: "GET", gateway: true },
      updateWorkkardField: { url: "/1.0/updatewrkkdfield", method: "POST", gateway: true },

      // Left panel: activities
      activityListing: { url: "/1.0/getactbyclmapi", method: "GET", gateway: true },
      activityNoteTemplates: { url: "/1.0/getactnotetemplates", method: "GET" },
      activityDetail: { url: "/1.0/gadapi", method: "GET" },
      activityTemplatesList: { url: "/gat", method: "GET" },
      updateActivityField: { url: "/1.0/updateactfield", method: "POST" },
      reassignActivity: { url: "/1.0/reaioactapi", method: "POST" },
      reassignActivityRequest: { url: "/1.0/gractapi", method: "GET" },
      activityWatcherList: { url: "/wtactsubuslst", method: "GET" },
      workkardWatcherList: { url: "/wtclmsubuslst", method: "GET" },

      // Right panel: associated workkards / filters / contact insured
      associatedWorkkard: { url: "/1.0/workkard/associated", method: "POST", gateway: true },
      associatedWorkkardFilter: { url: "/1.0/workkard/associated/filters", method: "POST", gateway: true },
      contactInsuredDetails: { url: "/getciinfoapi", method: "GET" },
      shareProposalDetails: { url: "/1.0/workkard/proposal/:workkard_id", method: "GET", gateway: true },
      shareProposal: { url: "/1.0/workkard/proposal/send/:workkard_id", method: "POST", gateway: true },
      saveContactInsuredDetails: { url: "/1.0/contactinsured", method: "POST" },
      reOpenReasonList: { url: "/getwkreopenreason", method: "GET" },

      // Notes (create note panel)
      allNoteTemplates: { url: "/1.0/note/templates", method: "GET", gateway: true },
      allDraftsCount: { url: "/1.0/galldc", method: "GET" },
      selectedNoteTemplateFields: { url: "/1.0/note/composer/", method: "GET" },
      allDraftNotes: { url: "/1.0/galld", method: "GET" },
      changeNoteType: { url: "/1.0/gntbnt", method: "GET" },
      changeNoteCreationActivityTemplate: { url: "/1.0/gactnotesdata", method: "GET" },
      publishActivityNote: { url: "/1.0/pubactntpub", method: "GET" },
      publishActivityNoteInternal: { url: "/1.0/pubactntpvt", method: "GET" },
      publishWorkkardNote: { url: "/1.0/pubclmntpub", method: "GET" },
      publishWorkkardNoteInternal: { url: "/1.0/pubclmntpvt", method: "GET" },
      deleteActivityNote: { url: "/1.0/delactnt", method: "GET" },
      deleteWorkkardNote: { url: "/1.0/delclmnt", method: "GET" },
      // discardSelectedNoteTemplate: { url: "/1.0/disdrnt", method: "POST" },
      publishDraftNote: { url: "/1.0/pubdn", method: "POST" },
      saveDraftNote: { url: "/1.0/savdrnt", method: "POST" },
      cloneToDraftNote: { url: "/1.0/gcldn", method: "POST" },
      editDraftNote: { url: "/1.0/gedn", method: "POST" },
      writeNoteReview: { url: "/1.0/rn", method: "GET" },

      // Middle panel: activity-scoped
      middlePanelNotes: { url: "/1.0/getclmnotes", method: "GET", gateway: true },
      middlePanelFiles: { url: "/1.0/getclmfiles", method: "GET", gateway: true  },
      middlePanelLogs: { url: "/1.0/getactlogs", method: "GET" },
      middlePanelDiaries: { url: "/1.0/acttdo", method: "GET" },
      middlePanelParties: { url: "/1.0/getpartiesinvlv", method: "GET" },

      // Middle panel: workkard-scoped
      middlePanelWorkkardNotes: { url: "/1.0/getclmnotes", method: "GET", gateway: true},
      middlePanelWorkkardFiles: { url: "/1.0/getclmfiles", method: "GET", gateway: true },
      middlePanelWorkkardLogs: { url: "/1.0/getworklogs", method: "GET" },
      middlePanelWorkkardDiaries: { url: "/1.0/clmtodo", method: "GET" },
      workkardTodoOwners: { url: "/1.0/wrkowntodo", method: "GET" },

      // Diaries actions
      diariesTitleEdit: { url: "/1.0/uptitletodo", method: "POST" },
      diariesDueDateEdit: { url: "/1.0/upduedatetodo", method: "POST" },
      diariesActionComplete: { url: "/1.0/TodoAction/CompleteTodo", method: "POST" },
      diariesActionCancelled: { url: "/1.0/tododel", method: "POST" },
      saveAndUpdateFileCaption: { url: "/1.0/asavedn", method: "POST" },
      updateFileCaption: { url: "/1.0/upcap", method: "POST" },

      // Files / letters
      workkardFilesReference: { url: "/1.0/getwrkfilesreference", method: "GET" },
      workkardLetters: { url: "/1.0/gateway/logs", method: "GET" },


      // Close activity / close workkard
      closeActivityOpenDiaries: { url: "/1.0/god", method: "GET" },
      closeActivityNotification: { url: "/1.0/gauid", method: "GET" },
      openActivities: { url: "/1.0/goa", method: "GET" },
      userAllOpenDiaries: { url: "/1.0/gowad", method: "GET" },
      userAllUnreadNotifications: { url: "/1.0/gaus", method: "GET" },
      // activityMenuActions: { url: "/1.0/aaapubn", method: "POST" },
      // updateActivityInProgress: { url: "/1.0/aaapubn", method: "POST" },
      bulkCompleteOpenDiaries: { url: "/1.0/blkcmpopdiary", method: "POST" },
      bulkCompleteOpenActivities: { url: "/1.0/clsactblkweb", method: "POST" },
      closeWorkkardBulkCompleteOpenDiaries: { url: "/1.0/comptodoblkweb", method: "POST" },
      changeActivityUpdateStatus: { url: "/1.0/activityupdate/changeactivityupdatestatus", method: "POST" },
      closeWorkkard: { url: "/1.0/clswkkd", method: "POST" },
      closeWorkkardPermission: { url: "/1.0/gclwkdpermission", method: "GET" },
      // closeActPermission: { url: "/1.0/gclactpermission", method: "GET" },

      // Parties
      deleteAssociatedParty: { url: "/1.0/delentpar", method: "POST" },

      // Misc
      setUserTourStatus: { url: "/1.0/updateapptourstatus", method: "POST" },
      getUserTourStatus: { url: "/1.0/getnewuserinfoapi", method: "GET" },
      timezoneByZip: { url: "/1.0/tzbyzip", method: "GET" },
      updateUserCustomFieldData: { url: "/1.0/updatecollapsiblefield", method: "POST" },
      resetUserCustomFieldData: { url: "/1.0/resetucfdata", method: "POST" },

      //SkillSet
      saveSkillsetTags: { url: "/1.0/activity/skillset", method: "POST" },
      updateOrgSkillsetApiEP: { url: "/1.0/organization/skillset", method: "PUT" },
      updateOrgProfileDataEP: { url: "/1.0/organization/profile", method: "PUT" },
      fetchOrgProfileDataEP: { url: "/1.0/organization/details", method: "GET" },

      //Service Locations
      fetchServiceLocation: {url: "/1.0/geodb/suggest", method: "GET"},
      fetchZipData: {url: "/1.0/geodb/list", method: "GET"},
      updateOrgServiceLocationEP: { url: "/1.0/organization/servicelocation", method: "PUT" },
      fetchDataByZip:{url: "/1.0/locations/zip", method: "GET"},
      
      //User
      updateUser: { url: "/2.0/user/", method: "PUT" },

      //FetchFiles
      fetchWorkkardActNoteFiles: { url: "/1.0/getwkfiles", method: "GET" },
    },
  },
};
